import React, { Component } from "react"
import "./RulesData.scss"
import ScrollableAnchor from "react-scrollable-anchor";
import Slider from "../Helpers/Slider/Slider";
import DataItem from "./DataItem"

// {
//     "name": "הזמן, בדקות, שתצטרך לשרוף בסופר של BringBring סופרמרקט אונליין בשביל להתארגן על הנשנושים ההכרחיים לקראת משחק הפתיחה של המונדיאל"
// },

class RulesData extends Component {
    constructor() {
        super();
        this.state = {}
    }
    getRules() {
        return this.props.jsonFile.map((item, index) => (index != 1 ? <DataItem key={index} index={index} ID={index + 1} name={item.name} /> : ""))
    }
    postRulesOnSlider() {
        return <Slider
            items={this.getRules()}
            loop={true}
            sectionName={this.props.sectionName}
            responsive={{
                0: {
                    items: 1,
                    slideBy: 1,
                    autoWidth: true,
                    rtl: true,
                    nav: true
                },
                1024: {
                    items: 2,
                    slideBy: 2,
                    center: false,
                    autoWidth: true,
                    rtl: true,
                    nav: true
                }
            }} />
    }
    render() {
        return (
            <ScrollableAnchor id={this.props.className}>
                <section className={`section section-rulesdata ${this.props.className}`}>
                    <div className="padding">
                        <div className="container">
                            <div className="slider">
                                {this.postRulesOnSlider()}
                            </div>
                        </div>
                    </div>
                </section>
            </ScrollableAnchor>
        )
    }
}

export default RulesData;


// WEBPACK FOOTER //
// ./src/Components/RulesData/RulesData.jsx